jQuery(document).ready(function ($) {
    var win = $(window);

    function alignHeight(selector) {
        $(selector).css('height', '');
        var minHeight = 0;
        $(selector).each(function () {
            if (minHeight < jQuery(this).outerHeight()) {
                minHeight = jQuery(this).outerHeight();
            }
        });
        if (minHeight > 0) {
            $(selector).css('height', minHeight);
        }
    }

    //slide media
    $('.thumbnail-slider .thumbnail-list').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        vertical: true,
        verticalSwiping: true,
        focusOnSelect:true,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                vertical: false,
                verticalSwiping: false,
                infinite: true,
            }
        },
        {
            breakpoint: 750,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                vertical: false,
                verticalSwiping: false,
                infinite: true,
                asNavFor: '.product__media-wrapper .product__media-list',
            }
        }
        ]
    });

    if($(window).width() < 750){
        var numberProductImage = $('.product__media-wrapper .product__media-list .product__media-item ').length;
        if(numberProductImage > 1) {
            $('.product__media-wrapper .product__media-list').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: true,
                asNavFor:'.product__media-wrapper .thumbnail-list',
                responsive: [{
                    breakpoint: 750,
                }
                ]
            });
        }
    }

    //Slide Recomment Product
    var load_recently_view = setInterval(function(){
        if($('.product-recommendations .product-grid').length) {
            $('.product-recommendations .product-grid').slick({
                infinite: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                responsive: [{
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: false
                    }
                },
                    {
                        breakpoint: 750,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: false,
                        }
                    }
                ]
            });
            alignHeight('.product-recommendations .card .card__information .card__heading');
            alignHeight('.product-recommendations .card .card__inner .card__media .media');
            alignHeight('.product-recommendations .card .card__information .product-brand');
            alignHeight('.product-recommendations .card .card__information .b-event-desc');
            alignHeight('.product-recommendations .card .card__information .b-recipe-desc');
            alignHeight('.product-recommendations .card .card__information .price');
            clearInterval(load_recently_view);
        }
    }, 1000);

    //Slide Frequently Product
    $('.product-frequently .featured-products-inner').slick({
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false
            }
        },
        {
            breakpoint: 750,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false,
            }
        }
        ]
    });

    //Click change main
    $('.template-product .product .product__media-wrapper media-gallery .thumbnail-slider .slick-arrow').click(function() {
        $(this).siblings().find('.thumbnail-list__item.slider__slide.slick-current.slick-active button').trigger('click');
    });

    //Scroll change main
    $(".thumbnail-slider .thumbnail-list").on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $('.thumbnail-list__item.slider__slide.slick-current.slick-active button')[0].click();
    });

    //Product-accordion
    $('.product-accordion.desktop h3').click(function () {
        $(this).next().slideToggle();
        $(this).toggleClass('active');
        $(this).parents('.product-accordion-detail').siblings().find('.content').slideUp();
        $(this).parents('.product-accordion-detail').siblings().find('h3').removeClass('active');
    });

    $('.product-accordion.mobile h3').click(function () {
        $(this).next().slideToggle();
        $(this).toggleClass('active');
        $(this).parents('.product-accordion-detail').siblings().find('.content').slideUp();
        $(this).parents('.product-accordion-detail').siblings().find('h3').removeClass('active');
    });

    //Warranty popup
    // class to remove/add z-index to on heders to stop overlapping of popup
    const announcementBar = document.querySelector('#shopify-section-announcement-bar')
    const headingBar = document.querySelector('#shopify-section-header') 
    const stickyHeader = document.querySelector('sticky-header')

    $('.warranty.s2 .learn-more').on('click', function() {
        $('.template-product .warranty-modal-popup').addClass('active');
        $('body').addClass('warranty-active');
        if (announcementBar) {
            announcementBar.style.zIndex = 0;
        }
        
        if (headingBar) {
            headingBar.style.zIndex = 0;
        }

        if (stickyHeader) {
            stickyHeader.style.display = 'none'
        }
    });
    
    $('.arranty-title-close').on('click', function() {
        $('.template-product .warranty-modal-popup').removeClass('active');
        $('body').removeClass('warranty-active');
        if (announcementBar) {
            announcementBar.style.zIndex = 3
        }
        
        if (headingBar) {
            headingBar.style.zIndex = 3
        }

        if (stickyHeader) {
            stickyHeader.style.display = 'block'
        }
    });
    
    $(document).mouseup(function(e) {
        var container = $(".template-product .warranty-modal-popup .warranty-content");
        
        if (!container.is(e.target) && container.has(e.target).length === 0)
        {
            $('.template-product .warranty-modal-popup').removeClass('active');
            $('body').removeClass('warranty-active');
            if (announcementBar) {
                announcementBar.style.zIndex = 3
            }
            
            if (headingBar) {
                headingBar.style.zIndex = 3
            }

            if (stickyHeader) {
                stickyHeader.style.display = 'block'
            }
        }
    });
    $('.warranty-learn-more a').on('click', function() {
         window.location = window.location.origin +'/pages/shipping-warranty';
    });

    //Afterpay popup
    $('.template-product .afterpay-logo').on('click', function() {
        $('.template-product .afterpay-link').trigger('click');
        $('body.template-product').css('overflow','hidden');
        $('.template-product .afterpay-link').addClass('active');
    });

    $('.template-product .afterpay-link').on('click', function() {
        $('body.template-product').css('overflow','hidden');
        $(this).addClass('active');
    });

    $(document).mouseup(function(e) {
        var afterpay = $(".template-product .afterpay-link");

        if (!afterpay.is(e.target) && afterpay.has(e.target).length === 0 && afterpay.hasClass('active'))
        {
             $('body.template-product').css('overflow','visible');
             $('.template-product .afterpay-link').removeClass('active');
        }
    });
    //Add space for Save price
    $(document).ready(function () {
        var widthleft = $('.template-product.product .product__info-wrapper .product-price .price__sale .price-item.price-item--sale').width() + 18;
        $('.template-product.product .product__info-wrapper .product-price .price__sale .price-item.price-item--sale .rrp-compare').css('left', widthleft);

        var widthleft2 = $('.template-product.product .product__info-wrapper .product-price .price__regular .price-item').width() + 20;
        $('.template-product.product .product__info-wrapper .rrp-no-compare').css('left', widthleft2);
    });
    //Change afterpay
    var afterpaytextfirst = $('.template-product.product .product__info-wrapper .afterpay-paragraph span.afterpay-text1').text().substring(8);
    $('.template-product.product .product__info-wrapper .afterpay-paragraph span.afterpay-text1').text(afterpaytextfirst);

    var afterpayprice = $('.template-product.product .product__info-wrapper .afterpay-paragraph .afterpay-instalments').text().replace('\u00A0AUD','');
    $('.template-product.product .product__info-wrapper .afterpay-paragraph .afterpay-instalments').text(afterpayprice);

    var afterpaytexttwo = $('.template-product.product .product__info-wrapper .afterpay-paragraph span.afterpay-text2').text().replace('fortnightly','');
    $('.template-product.product .product__info-wrapper .afterpay-paragraph span.afterpay-text2').text(afterpaytexttwo);

    setInterval(function(){

        var inStock = $('.template-product.product .product__info-wrapper .product-form-add-to-cart .product-form .product-form__submit span').text();
        if (inStock.indexOf('Sold out') !== -1) {    
            $(document).ready(function () {
                $('.template-product.product .product__info-wrapper .product-form-add-to-cart').addClass('sold-out');
                $('.template-product.product .product__info-wrapper .product-form-sold-out').css('display','inline-block');
                $('.template-product.product .product__info-wrapper .bnpl-also').addClass('sold-out');
                $('.template-product .mobile-sticky.product-form-add-to-cart').addClass('sold-out');
            });
        }
        else {
            $(document).ready(function () {
                $('.template-product.product .product__info-wrapper .product-form-add-to-cart').removeClass('sold-out');
                $('.template-product.product .product__info-wrapper .product-form-sold-out').css('display','none');
                $('.template-product.product .product__info-wrapper .bnpl-also').removeClass('sold-out');
                $('.template-product .mobile-sticky.product-form-add-to-cart').removeClass('sold-out');
            });
        }

        //Style RRP product
        if ($('.template-product.product .price__regular').css('display') == 'block')
        {
           $('.template-product.product .product__info-wrapper .product-price .rrp-price').addClass('default');
        }
        else {
            $('.template-product.product .product__info-wrapper .product-price .rrp-price').removeClass('default');
        }
    }, 100);

    /*Remove ! in product page main*/
    $( window ).on("load", function() {
        var replacecharacter = $('.template-product.product .product__info-wrapper .price__sale .rrp-compare .text-save').text().replace('!','');
        $('.template-product.product .product__info-wrapper .price__sale .rrp-compare .text-save').text(replacecharacter);
    });

    /*Caculating shipping product page*/
    var quantityKG = $('.watehouse.s1.no-free .hidden').text();
    var shippingKG = 0;
    var priceKG = 0;
    for (var i = 0; i < 20; i++) {
        if (shippingKG >= quantityKG) {
            $('.watehouse.s1.no-free .price-shipping').text('$' + priceKG.toFixed(2));
            break;
        }

        if (i == 19) {
            $('.watehouse.s1.no-free .price-shipping').text('$199.00');
        }

        shippingKG = shippingKG + 5000;
        priceKG = priceKG + 9.95;
    }

    var countBase = 0;
    /*$('.media-main').on('touchmove', function() {
      
           for (var i = 1; i <= 20; i++) {
            console.log(Math.floor($(".slider--mobile").scrollLeft()));
            var tottal = Math.floor(($(".slider--mobile").scrollLeft() / ($(window).width() - 16)) + 2);
            console.log(tottal);
                    setTimeout(function() { 
                $('.thumbnail-list li[data-media-position='+ tottal +']').trigger('click');
            },200);
        }
        
        
    } );*/
});